import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import * as Common from '_common';
import * as Components from '_components';
import * as Utils from '_utils';
import * as Styles from './Button.module.scss';
function getClasses(props, isLink = false) {
    let classNames = {
        [Styles.btn]: !isLink,
        [Styles.active]: props.isActive || false,
        [Styles.not_active]: props.isActive === false,
    };
    classNames = Components.WithTileProps(props, classNames);
    return Utils.classNames(classNames);
}
export function Button(props) {
    const classes = getClasses(props);
    let content = props.children;
    if (props.icon) {
        content = (_jsxs(_Fragment, { children: [_jsx("span", { className: Styles.icon, children: props.icon }), props.children] }));
    }
    return (_jsx("button", { className: classes, disabled: props.isDisabled, onClick: props.onClick, children: content }));
}
export function SubmitButton(props) {
    const classes = getClasses(props);
    let content = props.children;
    if (props.icon) {
        content = (_jsxs(_Fragment, { children: [_jsx("span", { className: Styles.icon, children: props.icon }), props.children] }));
    }
    return (_jsx("button", { type: "submit", className: classes, disabled: props.isDisabled, onClick: props.onClick, children: content }));
}
export function ButtonLink(props) {
    const classes = getClasses(props);
    if (!props.to) {
        return _jsx(_Fragment, { children: props.children });
    }
    if (props.to?.startsWith('/')) {
        return (_jsx(NavLink, { className: classes, to: props.to, children: props.children }));
    }
    else {
        return (_jsx("a", { className: classes, href: props.to, children: props.children }));
    }
}
export function Link(props) {
    const classes = getClasses(props, true);
    if (!props.to) {
        return _jsx(_Fragment, { children: props.children });
    }
    if (props.to?.startsWith('/')) {
        return (_jsx(NavLink, { className: classes, to: props.to, children: props.children }));
    }
    else {
        return (_jsx("a", { className: classes, href: props.to, children: props.children }));
    }
}
export var BtnGroupType;
(function (BtnGroupType) {
    BtnGroupType[BtnGroupType["Horizontal"] = 0] = "Horizontal";
    BtnGroupType[BtnGroupType["Vertical"] = 1] = "Vertical";
    BtnGroupType[BtnGroupType["Grid"] = 2] = "Grid";
})(BtnGroupType || (BtnGroupType = {}));
export function BtnGroup(props) {
    const classes = Utils.classNames({
        [Styles.grp_horizontal]: props.type === BtnGroupType.Horizontal,
        [Styles.grp_vertical]: props.type === BtnGroupType.Vertical,
        [Styles.grp_grid]: props.type === BtnGroupType.Grid,
        [Styles.grp_small]: props.small,
    });
    return (_jsx(Common.Component, { name: 'btn-group', className: classes, children: props.children }));
}
export function RenderButton(component, index) {
    return (_jsx(Button, { children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
export function RenderButtonGroup(component, index) {
    return (_jsx(BtnGroup, { children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
